import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiService } from '../_services/api.service';
import { ChecksService } from '../_services/checks.service';
import { EncrDecrService } from '../_services/encode.decode.service';
import { NotificationService } from '../_services/notification.service';
import { AdminData } from '../_models/admin';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  userData: AdminData;

  processing: boolean = false;
  buttonText: string = "Update Profile";
  passwordButtonText: string = "Update Password";

  dataForm = this.fb.group({
    lastName: ["", Validators.required],
    firstName: ["", Validators.required],
    email: [{value: '', disabled: true}]
  }, {});
  
  get lastName() { return this.dataForm.get('lastName'); }
  get firstName() { return this.dataForm.get('firstName'); }
  get email() { return this.dataForm.get('email'); }

  passwordForm = this.fb.group({
    oldPassword: ["", Validators.required],
    newPassword: ["", Validators.required],
    confirmPassword: ["", Validators.required],
  }, {});
  
  get oldPassword() { return this.passwordForm.get('oldPassword'); }
  get newPassword() { return this.passwordForm.get('newPassword'); }
  get confirmPassword() { return this.passwordForm.get('confirmPassword'); }

  constructor(
    private fb: FormBuilder,
    private checkService: ChecksService,
    private apiService: ApiService,
    private notifyService: NotificationService,
    private EncrDecr: EncrDecrService
  ) {
    this.userData = this.checkService.checkSession();
  }

  ngOnInit(): void {
    console.log(this.userData);
    this.dataForm.patchValue({
      lastName: this.userData.lastName,
      firstName: this.userData.firstName,
      email: this.userData.email
    });
  }

  updateProfile() {
    var data: object = {
      lastName: this.dataForm.value.lastName,
      firstName: this.dataForm.value.firstName,
    };
    this.modifyData(data);

  }

  modifyData( data ) {
    this.processing = true;

    this.buttonText = "Saving...";
      
    this.apiService.modifyData(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {

          var currentTime = Math.floor((Date.now() / 1000) + (60 * 10));
          
          let randKey = this.checkService.getRandomString(32);
          var keydata = {
            key: randKey,
            expire: currentTime.toString()
          }

          localStorage.setItem('key', btoa( JSON.stringify(keydata)) );
          localStorage.setItem('userData', this.EncrDecr.set(environment.localKey+randKey, JSON.stringify(user.data)));
          this.userData = user.data;
          this.notifyService.showSuccess("saved changes made to your profile", "Profile Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Update Profile";
      }
    );
  }

  updatePassword() {
    var data: object = {
      oldPassword: this.passwordForm.value.oldPassword,
      newPassword: this.passwordForm.value.newPassword,
    };
    this.modifyPassword(data);

  }

  modifyPassword( data ) {
    this.processing = true;

    this.buttonText = "Saving...";
      
    this.apiService.modifyPassword(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("password modification saved", "Profile Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Update Profile";
      }
    );
  }

}